import React from "react";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import HeaderMenuItem from "../HeaderMenuItem";
import { CallToBook } from "../../../views/DisposalPage/components/CallToBook";
import { ourServicesMenuItems, businessMenuItems, providersMenuItems, sustainabilityItems, aboutUsMenuItems } from "../constants";
import { buildMenuItemsForDisposal } from "../helpers";
import history from "../../../history";
import classes from "@css/components/website/Header.module.css";

interface CustomerLoggedOutProps {
  isOpaque: boolean;
  showNumber: boolean;
  formId: string | null;
  isDisposalPage: boolean;
  pathname: string;
  posts: any[];
  handleLogin: () => void;
}

function CustomerLoggedOut({ isOpaque, showNumber, formId, isDisposalPage, pathname, posts, handleLogin }: CustomerLoggedOutProps) {
  const caseStudyItems = buildMenuItemsForDisposal(pathname, posts);
  const primaryButtonClasses = isOpaque ? classes.primaryButton : classes.primaryButtonDark;

  return (
    <>
      {/* Menu Items */}
      <div className={classes.menuContainer}>
        <HeaderMenuItem isOpaque={isOpaque} name="Our Services" menuItems={ourServicesMenuItems} extended={true} />

        {Boolean(isDisposalPage && caseStudyItems.length) && <HeaderMenuItem isOpaque={isOpaque} name="Case Studies" menuItems={caseStudyItems} />}

        {Boolean(isDisposalPage && !caseStudyItems.length) && (
          <Button
            disableRipple
            className={classes.menuButton}
            style={{ color: isOpaque ? "black" : "white" }}
            onClick={() => history.push("/case-studies")}
          >
            Case Studies
          </Button>
        )}

        <HeaderMenuItem isOpaque={isOpaque} name="Business" menuItems={businessMenuItems} />
        <HeaderMenuItem isOpaque={isOpaque} name="Providers" menuItems={providersMenuItems} />
        <HeaderMenuItem isOpaque={isOpaque} name="Sustainability" menuItems={sustainabilityItems} />
        <HeaderMenuItem isOpaque={isOpaque} name="About" menuItems={aboutUsMenuItems} />
      </div>

      {/* Action Buttons */}
      <div className={classes.buttonContainer}>
        <div className={classes.buttonContainerInner}>
          {showNumber && <CallToBook formId={formId} condensed={true} header={true} />}

          <Button
            disableRipple
            onClick={handleLogin}
            className={isOpaque ? classes.secondaryButton : classes.secondaryButtonDark}
            variant="contained"
          >
            Log In
          </Button>

          <Link to="booking?step=initial" className={primaryButtonClasses}>
            Book Now
          </Link>
        </div>
      </div>
    </>
  );
}

export default CustomerLoggedOut;
